import dayjs, { type ConfigType } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const DEFAULT_TIMEZONE = "America/New_York";

export const dayjsTz = (...args: [] | [ConfigType?]) => {
  if (args.length === 0) return dayjs().tz(DEFAULT_TIMEZONE);
  return dayjsShow(args[0]);
};

/**
 * Show start / doors_open — naive datetimes stored as Eastern wall clock (Django USE_TZ=False).
 */
export const dayjsShow = (value: ConfigType) => {
  if (value == null || value === "") {
    return dayjs(NaN).tz(DEFAULT_TIMEZONE);
  }
  const raw = typeof value === "string" ? value.trim() : value;
  if (typeof raw === "string" && /([zZ]|[+-]\d{2}:?\d{2})$/.test(raw)) {
    return dayjs(raw).tz(DEFAULT_TIMEZONE);
  }
  return dayjs.tz(raw, DEFAULT_TIMEZONE);
};
